export default "__VITE_ASSET__zEb2ee1Y__"